<template>
  <div>
    <div v-if="!isLoading" class="bg-white h-100">
      <div class="d-flex justify-content-between align-items-center px-4 py-3 border-bottom">
        <i class="mdi" :class="icon" style="font-size: 1.5rem"></i>
        <h4 class="text-center m-0">{{ title }}</h4>
        <span class="clickable" @click="$emit('close')">
          <i class="mdi mdi-close" style="font-size: 1.5rem"></i>
        </span>
      </div>
      <div class="p-4">
        <LmTreeSelect
          label="Seleccione una opción"
          @input="onChangePassType"
          v-model="passType"
          :options="optionsPassType"
        />
        <div v-if="passType">
          <LmTreeSelect
            key="treeselect-area-component"
            v-if="passType.id === 'area'"
            clearable
            label="Área"
            pathToGetOptions="/customer/areas"
            v-model="pass"
          />
          <LmTreeSelect
            key="treeselect-subarea-area-component"
            v-if="passType.id === 'subarea'"
            clearable
            label="Área"
            pathToGetOptions="/customer/areas"
            v-model="areaPass"
          />
          <LmTreeSelect
            key="treeselect-subarea-component"
            v-if="passType.id === 'subarea'"
            clearable
            label="Subárea"
            pathToGetOptions="/customer/subareas"
            v-model="pass"
            childrenOf="areaPass"
          />
          <LmTreeSelect
            key="treeselect-user-component"
            v-if="passType.id === 'user'"
            clearable
            label="Usuario"
            :pathToGetOptions="`/users/all`"
            v-model="pass"
          />
          <LmTreeSelect
            key="treeselect-group-component"
            v-if="passType.id === 'group'"
            clearable
            label="Grupos"
            :pathToGetOptions="`/customer/groups`"
            v-model="pass"
          />
        </div>
        <LmButton
          type="button"
          buttonClass="btn-info"
          value="Realizar pase"
          @click="onPassProcess"
          :disabled="!pass || isLoading"
        />
      </div>
    </div>
    <LmLoading v-else />
  </div>
</template>

<script>
// Components
import LmTreeSelect from '@/components/form/elements/LmTreeSelect'
import LmButton from '@/components/form/elements/LmButton'

// Utils
import commonsApi from '@/api/commons'
import lmToasts from '@/mixins/lmToasts'

export default {
  provide () {
    const context = {}
    for (const key in this.context) {
      Object.defineProperty(context, key, {
        enumerable: true,
        get: () => this.context[key]
      })
    }
    return { context }
  },
  mixins: [lmToasts],
  components: {
    LmTreeSelect,
    LmButton
  },
  data () {
    return {
      areaPass: null,
      passType: null,
      pass: null,
      isLoading: false,
      isAreasySubareas: false
    }
  },
  computed: {
    context () {
      return {
        areaPass: this.areaPass
      }
    },
    optionsPassType () {
      let options = [{
        id: 'user',
        name: 'Usuarios'
      },
      {
        id: 'group',
        name: 'Grupos'
      }]
      if (process.env?.VUE_APP_ENABLE_AREAS_AND_SUBAREAS === 'yes') {
        options.splice(1, 0, {
          id: 'subarea',
          name: 'Áreas y Subáreas'
        })
      }
      return options
    }
  },
  props: {
    title: {
      type: String,
      required: true
    },
    icon: {
      type: String,
      required: true
    },
    processName: {
      type: String
    },
    changesUnsaved: {
      type: Boolean
    }
  },
  methods: {
    async onPassProcess () {
      try {
        this.isLoading = true
        await commonsApi.axiosPostWrapper('/processes/newmovement', {
          id: this.$route.params.id,
          destination: this.pass,
          destinationType: this.passType
        })

        this.lmModalSuccessWithButtons({
          modalClosable: false,
          modalKeyboard: false,
          buttons: [
            {
              btnText: this.$t('go_back'),
              btnCallback: async () => {
                this.$router.push('/inbox')
              }
            },
            {
              btnText: this.$t('continue'),
              btnCallback: async () => {
                this.$emit('onProcessPassChange', { [this.passType.name]: this.pass })
                this.$emit('close')
              }
            }
          ],
          message: this.$t('process.confirmations.movement_confirmation', {
            processName: this.processName,
            processDestination: this.pass.name
          })
        })
      } catch (error) {
        console.log(error)
      } finally {
        this.isLoading = false
      }
    },
    onChangePassType () {
      this.pass = null
      this.areaPass = null
    }
  }
}
</script>
